<template>

	<!-- content -->
	<div class="container">
		<div class="content">
			<section class="find">
				<h2 class="tit_page">아이디 찾기</h2>
				<form @submit.prevent="doSearch">
					<div class="find_form">
						<p class="guide_text">회원가입 시에 등록한 이름과, 휴대전화 정보를 입력해 주세요.</p>
						<div class="form_row">
							<label for="name" class="lab">이름</label>
							<input type="text" placeholder="이름" id="name" class="inp" v-model="userName" required="required">
						</div>
						<div class="form_row">
							<label for="phone" class="lab">휴대전화</label>
							<input type="tel" placeholder="휴대전화" id="phone" class="inp" v-model="phoneNo" required="required">
						</div>
					</div>
					<div class="find_button">
						<button type="submit" class="btn btn-lg btn_find">아이디 찾기</button>
					</div>
				</form>
			</section>
		</div>
	</div>
	<!--//content -->

</template>

<script>
export default {
	name: "findId",
	data() {

		return {
			userName: "",
			phoneNo: "",
		}
	},
	created() {

	},
	methods: {

		doSearch(e) {

			e.preventDefault()

			const self = this
			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.CO_ACCOUNT + "/doFindEmail", {
				userName: this.userName,
				phoneNo: this.phoneNo,
			}, (res) => {
				this.$eventBus.$emit("doneProgress")

				const result = res.data;
				if (result.status === "ok") {
					const coEmailIdArr = result.coEmailId.split("@");
					const emailEnc = self.stringUtils.idFilter(coEmailIdArr[0]) + "@" + coEmailIdArr[1];
					self.swalUtils.fire("계정확인", emailEnc, "success")
						.then(() => {
							self.userName = "";
							self.phoneNo = "";
						});
				} else {
					self.swalUtils.gritter(result.warnLevel == 1 ? "Info" : "Error", result.msg, result.warnLevel == 1 ? "info" : "error", 5000);
				}
			})


		}

	}
}
</script>

<style scoped>

</style>